import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
  useCarouselStep,
} from '@listening/frontend/components/radix/carousel';
import { useCallback, useState } from 'react';

import { rootLogger } from '@/lib/root-logger';
import { useAnalytics } from '@listening/frontend/analytics/client';
import {
  usePostPurchaseActions,
  usePostPurchaseStep,
} from './post-purchase.store';
import { postPurchasePages } from './post-purchase-pages';

const moduleLogger = rootLogger.child({
  module: 'PostPurchaseCarouselContent',
});

export function PostPurchaseCarouselContent() {
  const [api, setApi] = useState<CarouselApi>();
  const { current } = useCarouselStep(api);
  const currentStep = usePostPurchaseStep();
  const { nextStep } = usePostPurchaseActions();
  const { capture } = useAnalytics();
  const continueStep = useCallback(
    (pageName: string) => {
      capture('post_purchase_flow_next_screen', {
        currentPageName: pageName,
        currentPageIdx: current - 1,
      });
      moduleLogger.info(
        `Continue to next step: ${(currentStep + 1).toString()}`,
      );
      api?.scrollNext();
      nextStep();
    },
    [current, currentStep, api, nextStep, capture],
  );

  return (
    <Carousel
      className='flex size-full items-center justify-center overflow-hidden'
      opts={{
        watchDrag: false,
      }}
      setApi={setApi}
    >
      <CarouselContent className='size-full' wrapperClassName='w-full h-full'>
        {postPurchasePages.map(({ Component, pageName }, index) => (
          <CarouselItem
            className='flex items-center justify-center'
            inert={current !== index + 1 ? true : undefined}
            key={pageName}
          >
            <Component
              continueStep={() => {
                continueStep(pageName);
              }}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
}
